import { API_CONFIG, apiFetch, handleApiResponse, getPrismaticHeaders } from "./api";

function buildCopilotHeaders(): Record<string, string> {
  const savedSettings = sessionStorage.getItem('apiSettings');
  const apiSettings = savedSettings ? JSON.parse(savedSettings) : {};
  const prismaticApiKey = localStorage.getItem('prismaticApiKey') || apiSettings.prismaticApiKey as string | undefined;
  const prismaticApiUrl = localStorage.getItem('prismaticApiUrl') || apiSettings.prismaticApiUrl as string | undefined;

  const headers: Record<string, string> = { "Content-Type": API_CONFIG.headers.contentType };
  if (prismaticApiKey && prismaticApiUrl) {
    return getPrismaticHeaders(prismaticApiKey, prismaticApiUrl);
  }

  return headers;
}

export interface ChatMessageResponse {
  chatMessageId: string;
  authorRole: "User" | "Assistant";
  createdAt: string;
  message: string;
}

export interface CreateChatResponse {
  chatId: string;
}

export interface ChatResponse {
  chatId: string;
  messages: ChatMessageResponse[];
}

export async function createChat(systemMessage?: string): Promise<CreateChatResponse> {
  const url = `${API_CONFIG.baseUrl}${API_CONFIG.endpoints.copilotChats}`;
  const headers: Record<string, string> = { "Content-Type": API_CONFIG.headers.contentType };
  const response = await apiFetch(url, {
    method: "POST",
    headers,
    body: systemMessage ? JSON.stringify({ systemMessage }) : undefined,
  });
  return handleApiResponse<CreateChatResponse>(response);
}

export async function getChat(chatId: string): Promise<ChatResponse> {
  const encodedId = encodeURIComponent(chatId);
  // includeMessages=true to fetch history
  const url = `${API_CONFIG.baseUrl}${API_CONFIG.endpoints.copilotChats}/${encodedId}?includeMessages=true`;
  const response = await apiFetch(url, { method: "GET" });
  return handleApiResponse<ChatResponse>(response);
}

export async function sendMessage(
  chatId: string,
  message: string,
  activePageContext: Record<string, unknown>
): Promise<ChatMessageResponse> {
  const encodedId = encodeURIComponent(chatId);
  const url = `${API_CONFIG.baseUrl}${API_CONFIG.endpoints.copilotChats}/${encodedId}/messages`;

  const headers = buildCopilotHeaders();

  const response = await apiFetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({
      message: message,
      activePageContext,
    }),
  });
  return handleApiResponse<ChatMessageResponse>(response);
}
